import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'
import Buttons from './Buttons'
import GridView from './GridView'
import ListView from './ListView'
import BreadCrumbs from './BreadCrumbs'
import RenderFilters from './RenderFilters'
import EmailDeliveryStatus from './EmailDeliveryStatus'
import RenderProperties from './RenderProperties'
import RenderFileHistory from './RenderFileHistory'
import AlertBox from './AlertBox'
import RenderAppliedFilter from './RenderAppliedFilter'

import { constants } from '../constants/constants'
import { apiConstants } from '../constants/apiConstants'
import { fileOptionsConstants } from '../constants/fileOptions'
import { shareConstants } from '../constants/shareConstants'
import { errorConstants } from '../constants/errorConstants'
import { getErrorMessage } from '../constants/errorMessage'
import { isNotProperFileName } from '../../../server/src/routes/validator'

import {
  filterBasedOnDate,
  filterFileList,
  searchFileNameInList,
  filterBasedOnSize,
  filterFileListBasedOnField,
} from '../helpers/filter'
import {
  checkUserPermissionForSharedFolder,
  validateFolderName,
  sortFiles,
  removeExtraSlashes,
  removeTrailingSlashes,
  constructUploadFileErrorMessage,
  isCorpOrGoPayUser,
  getLocalizedContent,
  isFile,
} from '../helper'

import {
  fetchMetaDataOfFileOrFolder,
  createFolder,
  moveOrRenameFileOrFolder,
  copyFileOrFolder,
  fetchFolderData,
  fetchOrUpdateShareeDetails,
  deleteFileOrFolder,
} from '../api/request'

import Pagination from './Pagination'

import caller from '../caller'

class Views extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      queryRequest: [],
      showOptions: false,
      selectedItem: '',
      files: {},
      showButton: false,
      showCreateFolder: false,
      isFilesFetchInProgress: false,
      baseFolder: this.props.baseFolder,
      showPagination: false,
      viewType: constants.View,
      showProperties: false,
      showPropertiesForItem: {},
      errorMsg: { msg: '', status: 'success' },
      isCreateFolderInProgress: false,
      itemToMove: {},
      hasItemToMove: false,
      itemToCopy: {},
      hasItemToCopy: false,
      fileToRename: {},
      hasFileToRename: false,
      renameIsInProgress: false,
      multipleSelectItems: [],
      options: [],
      itemToDelete: [],
      itemToUnshare: [],
      searchQuery: {},
      itemToDownload: [],
      alertBox: {
        status: false,
        msg: '',
        sec_msg: '',
        action: [],
        for: {},
      },
      showMoveOrCopyToList: false,
      moveOrCopyFolderDetails: [],
      folderListFetchInProgress: false,
      showAdvnFilterBox: false,
      advnFilterBoxPosition: [],
      pageNo: this.props.pageNo,
      showDeliveryStatus: false,
      fetchDeliveryStatusInProgress: false,
      deliveryStatusErrorMessage: { msg: '', status: 'success' },
      selectedItemToViewDeliveryStatus: {},
      showFileHistory: false,
      showFileHistoryForItem: {},
      isPathFromURLRedirect: false,
      previousBaseFolder: '',
      filesToBeVerifiedFromUserBeforeUpload: [],
      displayingAlertBoxForFile: {},
      renderUploadFile: false,
      isBreadCrumbClick: false,
    }
    this.itemRemainingToDownload = []
    this.advnRef = React.createRef()
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!_.isEqual(nextProps.files, prevState.files)) {
      return {
        files: nextProps.files,
      }
    }
    if (prevState.baseFolder !== nextProps.baseFolder) {
      return {
        baseFolder: nextProps.baseFolder,
      }
    }
    return null
  }

  componentDidMount() {
    const pathParam = removeExtraSlashes(
      this.props.location.pathname.replace(apiConstants.URLPrefix, ''),
    )
    if (pathParam !== '') {
      this.getMetaDataOfTheFolder(pathParam, true, false)
    } else {
      this.constructFetchQuery(apiConstants.Root, false)
    }
    document.addEventListener('click', this.handleClick, false)
    document.addEventListener('keydown', this.handleKeydown, false)
  }

  getMetaDataOfTheFolder = async (
    pathParam,
    isURLRedirect,
    isBreadCrumbClick,
  ) => {
    this.setStateValues('isFilesFetchInProgress', true)
    this.props.actions.setSelectedFolderToSearch({})
    this.props.actions.setUserPermissionForFolder(
      shareConstants.FilePermissions.list,
    )
    const metaDataResponse = await fetchMetaDataOfFileOrFolder(pathParam)
    if (metaDataResponse.status === 200) {
      this.updateMetaDataResult(metaDataResponse)
      if (isURLRedirect) {
        this.fetchDataForURLRedirect(pathParam)
      }
      if (isBreadCrumbClick) {
        this.setState({ isBreadCrumbClick: false })
      }
    } else {
      this.setStateValues('isFilesFetchInProgress', false)
      this.constructErrorMessage(metaDataResponse)
    }
    return true
  }

  updateMetaDataResult = (metaDataResponse) => {
    const { user, userPermission } = this.props
    const result = _.get(JSON.parse(metaDataResponse.text), 'results', [])
    if (result.length > 0) {
      if (_.get(result, '[0].fileType') !== 'file') {
        this.props.actions.setSelectedFolderToSearch(result[0])
      }
      this.props.actions.setUserPermissionForFolder(
        checkUserPermissionForSharedFolder(result[0], user, userPermission),
      )
    }
  }

  fetchDataForURLRedirect = (pathParam) => {
    this.setBaseFolder(`/${decodeURI(pathParam)}`)
    this.setURLPathStatus(true)
  }

  setURLPathStatus = (isPathFromURLRedirect) => {
    this.setState({ isPathFromURLRedirect })
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
    document.removeEventListener('keydown', this.handleKeydown, false)
    this.abortRequests()
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleDisplayAlertBoxForUpload(prevProps, prevState)
    this.handleViewChange(prevState)
    this.handleErrorChange(prevState)
    this.handlePageRefresh()
    this.handleFilterAndDateChange(prevProps, prevState)
  }

  handleDisplayAlertBoxForUpload = (prevProps, prevState) => {
    const {
      filesToBeVerifiedFromUserBeforeUpload,
      displayingAlertBoxForFile,
    } = this.state
    if (
      !_.isEqual(displayingAlertBoxForFile, prevState.displayingAlertBoxForFile)
    ) {
      if (
        filesToBeVerifiedFromUserBeforeUpload.length > 0 &&
        _.get(displayingAlertBoxForFile, 'file.name', '') !== ''
      ) {
        this.displayAlertForUpload(filesToBeVerifiedFromUserBeforeUpload[0])
      }
    }
  }

  handleViewChange = async (prevState) => {
    const { baseFolder, viewType, searchQuery, isBreadCrumbClick } = this.state
    if (
      baseFolder !== prevState.baseFolder ||
      viewType !== prevState.viewType
    ) {
      if (baseFolder === '/' && searchQuery.hasOwnProperty('quickSearch')) {
        return
      }
      if (isBreadCrumbClick) {
        await this.getMetaDataOfTheFolder(baseFolder, false, isBreadCrumbClick)
      }
      this.constructFetchQuery(
        baseFolder === '/' ? apiConstants.Root : baseFolder,
        true,
      )
    }
  }

  handleErrorChange = (prevState) => {
    const { errorMsg } = this.state
    if (!_.isEqual(errorMsg, prevState.errorMsg)) {
      if (errorMsg.status !== 'info') {
        setTimeout(
          () => this.setState({ errorMsg: { msg: '', status: 'success' } }),
          7000,
        )
      }
    }
  }

  handlePageRefresh = () => {
    const { baseFolder } = this.state
    const { refresh } = this.props
    if (refresh) {
      this.removeFileAction()
      this.removeStateValuesOnFileOperation()
      this.constructFetchQuery(
        baseFolder === '/' ? apiConstants.Root : baseFolder,
        true,
      )
      if (baseFolder === '/') {
        this.props.actions.setSharedFolderDetails({})
      }
      this.props.setRefreshState(false)
    }
  }

  handleFilterAndDateChange = (prevProps, prevState) => {
    const { baseFolder, searchQuery } = this.state
    const { startDate, endDate } = this.props
    if (
      startDate !== prevProps.startDate ||
      endDate !== prevProps.endDate ||
      !_.isEqual(searchQuery, prevState.searchQuery)
    ) {
      if (_.has(searchQuery, 'sharedWith')) {
        this.constructFetchQuery(
          baseFolder === '/' ? apiConstants.Root : baseFolder,
          true,
          { sharedWith: searchQuery.sharedWith },
        )
      } else if (
        _.has(searchQuery, 'quickSearch') &&
        !_.isEqual(
          searchQuery.quickSearch,
          prevState.searchQuery.quickSearch,
        ) &&
        baseFolder !== '/'
      ) {
        this.constructFetchQuery(apiConstants.Root, true)
      } else {
        this.getFileListBasedOnFilter(searchQuery, prevState.searchQuery)
      }
    }
  }

  sortFileList = (sortType, sortBy) => {
    const { files } = this.props
    const results = sortFiles(files.results, sortBy, sortType)
    const finalResult = {
      total: files.total,
      results,
    }
    this.props.actions.setFileDetails(finalResult)
  }

  updateFileListBasedOnSearch = (searchValue) => {
    const {
      fileList,
      startDate,
      endDate,
      sortBy,
      sortType,
      baseFolder,
    } = this.props
    const { searchQuery } = this.state
    let searchResult = fileList.results
    if (_.has(searchQuery, 'quickSearch') && baseFolder === '/') {
      searchResult = this.filterBasedOnQuickSearch(
        searchQuery,
        fileList,
        searchResult,
      )
    }
    searchResult = searchFileNameInList(searchResult, searchValue)
    searchResult = filterBasedOnDate(searchResult, startDate, endDate)
    searchResult = sortFiles(searchResult, sortBy, sortType)
    this.props.actions.setFileDetails({
      total: searchResult.length,
      results: searchResult,
    })
  }

  filterBasedOnQuickSearch = (searchQuery, fileList, filterResult) => {
    if (!_.has(searchQuery, 'quickSearch')) {
      return []
    }
    if (searchQuery.quickSearch === 'allFiles') {
      return fileList.results
    }
    if (searchQuery.quickSearch === 'sharedWith') {
      return filterFileListBasedOnField(filterResult, 'sharedBy')
    }
    if (searchQuery.quickSearch === 'sharedBy') {
      return filterFileList(filterResult, { isShared: true })
    }
    return []
  }

  getFileListBasedOnFilter = (
    searchQuery,
    prevSearchQuery = {},
    files = {},
  ) => {
    const {
      fileList,
      sortBy,
      sortType,
      startDate,
      endDate,
      baseFolder,
    } = this.props
    let filterResult = _.has(files, 'results')
      ? files.results
      : fileList.results
    this.setStateValues('isFilesFetchInProgress', true)

    /* Filter file list based on quick search */
    if (_.has(searchQuery, 'quickSearch') && baseFolder === '/') {
      filterResult = this.filterBasedOnQuickSearch(
        searchQuery,
        fileList,
        filterResult,
      )
    }
    /* Filter file list files based on date */
    filterResult = filterBasedOnDate(filterResult, startDate, endDate)

    /* Filter file list files based on other filters */
    if (
      !_.isEqual(searchQuery, prevSearchQuery) ||
      Object.keys(searchQuery).length > 0
    ) {
      let newSearchQuery = searchQuery
      if (
        _.has(searchQuery, ['size']) ||
        _.has(searchQuery, ['quickSearch']) ||
        _.has(searchQuery, ['sharedWith'])
      ) {
        newSearchQuery = _.omit(newSearchQuery, [
          'size',
          'quickSearch',
          'sharedWith',
        ])
      }
      filterResult = filterFileList(filterResult, newSearchQuery)
    }

    /* Filter file list files based on size */
    if (_.has(searchQuery, 'size')) {
      filterResult = filterBasedOnSize(
        filterResult,
        searchQuery.size[0],
        searchQuery.size[1],
      )
    }

    /* Finally sort the filtered file list */
    filterResult = sortFiles(filterResult, sortBy, sortType)
    this.props.actions.setFileDetails({
      total: filterResult.length,
      results: filterResult,
    })
    this.setStateValues('isFilesFetchInProgress', false)
  }

  handleClick = (e) => {
    const { showAdvnFilterBox } = this.state
    if (showAdvnFilterBox) {
      if (this.advnRef.current.contains(e.target)) {
        return
      }
      if (e.target.classList.value.includes('filterRef')) {
        return
      }
      this.setState({ showAdvnFilterBox: false, advnFilterBoxPosition: [] })
    }
  }

  handleKeydown = (event) => {
    const { keyCode } = event
    const {
      showOptions,
      showProperties,
      showFileHistory,
      showAdvnFilterBox,
      showDeliveryStatus,
      showMoveOrCopyToList,
    } = this.state
    if (keyCode === 27) {
      if (showAdvnFilterBox) {
        this.setState({ showAdvnFilterBox: false, advnFilterBoxPosition: [] })
      }

      if (showProperties) {
        this.closePropertyBox()
      }

      if (showFileHistory) {
        this.closeFileHistoryBox()
      }

      if (showDeliveryStatus) {
        this.closeDeliveryStatusBox()
      }

      if (showOptions) {
        this.fileOptionStatus('', false)
      }

      if (showMoveOrCopyToList) {
        this.setState({ showMoveOrCopyToList: false })
      }
    }
  }

  constructFetchQuery = (
    path,
    resetPage,
    params = {},
    isSharedByMeOrSharedWithMe = '',
  ) => {
    if (resetPage) {
      this.setPageNoAndPaginationStatus()
    }
    this.fetchSearchData(path, params, isSharedByMeOrSharedWithMe)
  }

  removeFileAction = () => {
    this.setState({
      itemToMove: {},
      hasItemToMove: false,
      itemToCopy: {},
      hasItemToCopy: false,
      fileToRename: {},
      hasFileToRename: false,
      itemToDelete: [],
      itemToUnshare: [],
      itemToDownload: [],
    })
  }

  removeStateValuesOnFileOperation = () => {
    this.setState({
      selectedItem: '',
      multipleSelectItems: [],
      showButton: false,
      showOptions: false,
      options: [],
    })
  }

  changeView = (id) => {
    this.setState({ viewType: id })
    this.fileOptionStatus('', false)
  }

  setStateValues = (state, value) => {
    this.setState({ [state]: value })
  }

  setPageNoAndPaginationStatus = () => {
    this.props.actions.setPageNo(1)
    this.setState({ showPagination: false })
  }

  onPaginationClick = (pageNo) => {
    this.setState({
      pageNo,
      selectedItem: '',
      showOptions: false,
      options: [],
    })
  }

  abortRequests = () => {
    const { queryRequest } = this.state
    queryRequest.forEach((request) => {
      if (request) request.abort()
    })
  }

  fetchSearchData = (path, params, isSharedByMeOrSharedWithMe = '') => {
    const { user, sharedFolderDetails, shareePath } = this.props

    window.scrollTo(0, 0)
    let queryRequest = []
    this.abortRequests()
    this.setStateValues('isFilesFetchInProgress', true)
    let url = ''

    if (sharedFolderDetails.shareePath) {
      path = `${shareePath}`
    }

    if (path === '/' || path === '') {
      path = `${apiConstants.Root}/`
      this.props.setBaseFolder('/')
    }

    if (isSharedByMeOrSharedWithMe === '') {
      url = `${apiConstants.URLPrefix}/${user.accType}/${user.username}/path/${path}${apiConstants.SearchURLSuffix}`
    } else {
      url = `${apiConstants.URLPrefix}/${user.accType}/${user.username}/path/${path}${apiConstants[isSharedByMeOrSharedWithMe]}`
    }

    queryRequest.push(this.fetchSearch(url, params))

    this.setState({ queryRequest })
  }

  fetchSearch = (url, data) => {
    const queryRequest = caller.search(url, data, (res) => {
      this.searchResult(res, data)
    })
    return queryRequest
  }

  updateSearchResult = (data, fileList, searchQuery, limit) => {
    if (!_.has(data, 'sharedWith')) {
      this.props.actions.setFileListFromResponse(fileList)
    }
    this.props.actions.setFileDetails(
      this.getFileListBasedOnFilter(searchQuery, {}, fileList),
    )
    this.setState({
      showPagination: Math.ceil(fileList.total / limit) > 1,
      isPathFromURLRedirect: false,
      isFilesFetchInProgress: false,
    })
    if (fileList.results.length > 0) {
      this.setState({ baseFolder: fileList.results[0].baseFolder })
    }
  }

  updateSearchResultForURLRedirect = (fileList, data, searchQuery) => {
    const { limit, baseFolder } = this.props
    const fileFromURLPath = fileList.results.filter(
      (file) =>
        `/${removeExtraSlashes(file.path)}` === baseFolder &&
        file.fileType === 'file',
    )
    const fileName = `/${removeExtraSlashes(baseFolder)}`.split('/').pop()

    if (
      fileFromURLPath.length === 1 &&
      fileList.results.length === 1 &&
      _.get(fileFromURLPath, '[0].fileName', '') === fileName
    ) {
      this.setBaseFolder(
        `/${removeExtraSlashes(fileFromURLPath[0].baseFolder)}`,
      )

      this.props.history.push(
        `${apiConstants.URLPrefix}/${removeExtraSlashes(
          fileFromURLPath[0].baseFolder,
        )}`,
      )
      if (
        _.get(fileFromURLPath, '[0].permission', '') !== 'list' &&
        _.get(fileFromURLPath, '[0].fileType', '') === 'file'
      ) {
        this.displayAlertBox(
          fileFromURLPath[0],
          'download',
          [getLocalizedContent('alert.download')],
          true,
          'warning',
        )
      }
    } else {
      this.setSharedDetailsInfo(
        _.has(fileList.results[0], 'sharedBy') ? fileList.results[0] : {},
      )
      this.updateSearchResult(data, fileList, searchQuery, limit)
    }
  }

  searchResult(res, data) {
    const { limit } = this.props
    const {
      isPathFromURLRedirect,
      searchQuery,
      previousBaseFolder,
    } = this.state
    if (res.status === 200) {
      const responseData = JSON.parse(res.text)
      const searchResult = _.get(responseData, 'results', [])
      const fileList = {
        total: searchResult.length,
        results: searchResult,
      }
      this.setState({ previousBaseFolder: '' })
      if (isPathFromURLRedirect) {
        this.updateSearchResultForURLRedirect(fileList, data, searchQuery)
      } else {
        this.updateSearchResult(data, fileList, searchQuery, limit)
      }
    } else {
      this.props.setBaseFolder(
        previousBaseFolder === '' ? '/' : previousBaseFolder,
      )
      this.props.history.push(`${apiConstants.URLPrefix}${previousBaseFolder}`)
      if (
        (_.get(searchQuery, 'quickSearch', '') !== '' &&
          previousBaseFolder === '/') ||
        previousBaseFolder === ''
      ) {
        const fileList = {
          total: 0,
          results: [],
        }
        this.props.actions.setFileDetails(fileList)
      }
      this.setState({
        isPathFromURLRedirect: false,
        isFilesFetchInProgress: false,
      })
      this.constructErrorMessage(res)
    }
  }

  setDateTime = (date) => {
    if (date >= 10) {
      return date
    }
    return `0${date}`
  }

  onCreateFolderSuccess = (folder) => {
    const {
      baseFolder,
      files,
      folderList,
      fileList,
      selectedFolderToSearch,
    } = this.props

    const today = new Date()

    const date = `${today.getFullYear()}-${this.setDateTime(
      today.getMonth() + 1,
    )}-${this.setDateTime(today.getDate())} ${this.setDateTime(
      today.getHours(),
    )}:${this.setDateTime(today.getMinutes())}:${this.setDateTime(
      today.getSeconds(),
    )}`

    const newFolder = {
      baseFolder,
      createdDate: date,
      fileName: folder,
      fileType: 'folder',
      isShared: false,
      modifiedDate: date,
      path: baseFolder === '/' ? `/${folder}` : `${baseFolder}/${folder}`,
      size: 4096,
    }

    const newFolderInfo = {
      ...newFolder,
      ..._.pick(selectedFolderToSearch, shareConstants.NeededShareeDetails),
    }

    if (baseFolder === '/') {
      if (folderList.results) {
        folderList.results.unshift(newFolderInfo)
      } else {
        folderList.total = 1
        folderList.results = []
        folderList.results.push(newFolderInfo)
      }
      folderList.results = _.sortBy(folderList.results, ['fileName'])
      folderList.total = folderList.results.length
      this.props.actions.setTree(folderList)
      this.props.setFolderStructure(folderList)
    }
    if (files.results) {
      files.results.unshift(newFolderInfo)
    } else {
      files.results = []
      files.results.push(newFolderInfo)
    }
    if (fileList.results) {
      fileList.results.unshift(newFolderInfo)
    } else {
      fileList.results = []
      fileList.results.push(newFolderInfo)
    }
    files.total = files.results.length
    fileList.total = fileList.results.length
    this.props.actions.setFileDetails(files)
    this.props.actions.setFileListFromResponse(fileList)
  }

  capture = (folder, showCreateFolder) => {
    const folderName = folder.trim()
    window.scrollTo(0, 0)
    const validateMsg = validateFolderName(folderName, 'folder')

    if (folderName !== '' && validateMsg === '') {
      this.triggerCreateFolder(folderName, showCreateFolder)
    } else if (folderName !== '') {
      this.updateErrorMessage(validateMsg)
    } else {
      this.setState({ showCreateFolder })
    }
  }

  triggerCreateFolder = async (folderName, showCreateFolder) => {
    const { baseFolder } = this.props
    this.setState({ isCreateFolderInProgress: true })

    const path =
      baseFolder === '/' ? `/${folderName}` : `${baseFolder}/${folderName}`
    const createFolderResponse = await createFolder(path)

    if (createFolderResponse.status === 201) {
      if (baseFolder !== '/') {
        this.triggerTreeViewFetch()
      }
      this.onCreateFolderSuccess(folderName)
      this.updateCreateFolderState(
        {
          msg: getLocalizedContent('success.create.folder'),
          status: 'success',
        },
        showCreateFolder,
        false,
      )
    } else {
      this.updateCreateFolderState(
        { msg: '', status: 'success' },
        showCreateFolder,
        false,
      )
      this.constructErrorMessage(createFolderResponse)
    }
  }

  updateCreateFolderState = (
    errorMsg,
    showCreateFolder,
    isCreateFolderInProgress,
  ) => {
    this.setState({
      errorMsg,
      showCreateFolder,
      isCreateFolderInProgress,
    })
  }

  setCreateNewFolderVisibility = () => {
    this.setState({
      showCreateFolder: true,
      selectedItem: '',
      showOptions: false,
      showButton: false,
      errorMsg: { msg: '', status: 'success' },
      searchQuery: {},
    })
    this.props.setQuickSearch('allFiles')
  }

  fileOptionStatus = (selectedItem, showOptions) => {
    this.setState((prevState) => ({
      selectedItem,
      showOptions,
      showButton: false,
      options: [],
      errorMsg: { msg: '', status: 'success' },
      multipleSelectItems: showOptions ? [] : prevState.multipleSelectItems,
    }))

    this.fileOptionStatusAdditional()
    this.renderOptionsList()
  }

  fileOptionStatusAdditional = () => {
    this.setState({
      moveOrCopyFolderDetails: [],
      showMoveOrCopyToList: false,
      folderListFetchInProgress: false,
    })
  }

  clickItems = (e, selectedItemPath, selectAll = false) => {
    const { files } = this.state
    let { multipleSelectItems } = this.state
    let buttonOption = []

    multipleSelectItems = this.getSelectedItemsList(
      e,
      selectedItemPath,
      selectAll,
      multipleSelectItems,
      files.results,
    )
    if (multipleSelectItems.length > 0) {
      buttonOption = this.getButtonOptions(multipleSelectItems, buttonOption)
    }
    this.setState({
      multipleSelectItems,
      showButton: multipleSelectItems.length > 0,
      options: buttonOption,
    })
  }

  getButtonOptions = (multipleSelectItems, buttonOption) => {
    const { userPermission } = this.props
    let sharedToOtherUserFolderCount = 0,
      sharedByOtherUserFolderCountOnRoot = 0,
      folderCount = 0,
      fileCount = 0

    multipleSelectItems.map((file) => {
      if (file.isShared) {
        sharedToOtherUserFolderCount++
      }
      if (file.fileType === 'folder') {
        folderCount = folderCount + 1
      } else {
        fileCount = fileCount + 1
      }
      fileOptionsConstants.FileOptionsOutside.map((fileItem) => {
        if (file.fileType === fileItem.type) {
          if (buttonOption.length === 0) {
            buttonOption = fileItem.options
          } else {
            buttonOption = buttonOption.filter((n) =>
              fileItem.options.some((n2) => n.option === n2.option),
            )
          }
        }
        if (file.sharedBy && file.baseFolder === '/') {
          sharedByOtherUserFolderCountOnRoot++
        }
      })
      buttonOption = this.filterButtonBasedOnPermission(
        buttonOption,
        file,
        userPermission,
      )
      buttonOption = this.filterButtonBasedOnPermissionOnFileAndFolder(
        buttonOption,
        userPermission,
        folderCount,
      )
    })

    buttonOption = this.filterButtonsForFolderSharedToOthers(
      buttonOption,
      sharedByOtherUserFolderCountOnRoot,
    )
    buttonOption = this.filterButtonsForFolderSharedWithOthers(
      buttonOption,
      sharedToOtherUserFolderCount,
    )
    buttonOption = this.filterShareButton(buttonOption, multipleSelectItems)
    buttonOption = this.filterButtonsOnFileAndFolderSelected(
      buttonOption,
      folderCount,
      fileCount,
    )
    return buttonOption
  }

  getSelectedItemsList = (
    e,
    selectedItem,
    selectAll,
    multipleSelectItems,
    files,
  ) => {
    if (selectAll) {
      if (e.target.checked) {
        for (let i = 0; i < files.length; i++) {
          let item = multipleSelectItems.indexOf(files[i])
          if (item < 0) {
            multipleSelectItems.push(files[i])
          }
        }
      } else {
        multipleSelectItems = []
      }
    } else if (e.target.checked) {
      multipleSelectItems.push(selectedItem)
    } else {
      let item = multipleSelectItems.indexOf(selectedItem)
      if (item > -1) {
        multipleSelectItems.splice(item, 1)
      }
    }
    return multipleSelectItems
  }

  filterButtonsForFolderSharedToOthers = (
    buttonOption,
    sharedByOtherUserFolderCountOnRoot,
  ) => {
    const buttonsToBeRemovedForFolderSharedByOther = [
      'move',
      'copy',
      'delete',
      'share',
    ]
    if (sharedByOtherUserFolderCountOnRoot > 0) {
      return buttonOption.filter(function (button) {
        return !buttonsToBeRemovedForFolderSharedByOther.includes(button.key)
      })
    }
    return buttonOption
  }

  filterButtonsForFolderSharedWithOthers = (
    buttonOption,
    sharedToOtherUserFolderCount,
  ) => {
    const btnsToBeRemovedForSharedFolder = ['move', 'copy', 'delete']
    if (sharedToOtherUserFolderCount > 0) {
      return buttonOption.filter(function (button) {
        return !btnsToBeRemovedForSharedFolder.includes(button.key)
      })
    }
    return buttonOption
  }

  filterShareButton = (buttonOption, multipleSelectItems) => {
    if (multipleSelectItems.length > 1) {
      return buttonOption.filter((i) => i.option !== 'Share')
    }
    return buttonOption
  }

  filterButtonBasedOnPermission = (buttonOption, file, userPermission) => {
    const btnForPermissionUploadDownload = ['download', 'copy']
    const btnForPermissionOverwriteFile = ['download', 'delete', 'move', 'copy']
    if (file.hasOwnProperty('sharedBy')) {
      if (userPermission === shareConstants.FilePermissions.list) {
        buttonOption = []
      } else if (
        userPermission === shareConstants.FilePermissions.readWriteExecute
      ) {
        buttonOption = buttonOption.filter(function (button) {
          return btnForPermissionOverwriteFile.includes(button.key)
        })
      } else if (
        userPermission === shareConstants.FilePermissions.readWrite ||
        userPermission === shareConstants.FilePermissions.read
      ) {
        buttonOption = buttonOption.filter(function (button) {
          return btnForPermissionUploadDownload.includes(button.key)
        })
      }
    }
    return buttonOption
  }

  filterButtonBasedOnPermissionOnFileAndFolder = (
    buttonOption,
    userPermission,
    folderCount,
  ) => {
    const removeBtnForFolderAndFileReadWrite = ['copy']
    if (
      folderCount > 0 &&
      (userPermission === shareConstants.FilePermissions.readWrite ||
        userPermission === shareConstants.FilePermissions.read)
    ) {
      return buttonOption.filter(function (button) {
        return !removeBtnForFolderAndFileReadWrite.includes(button.key)
      })
    }
    return buttonOption
  }

  filterButtonsOnFileAndFolderSelected = (
    buttonOption,
    folderCount,
    fileCount,
  ) => {
    const removeBtnForFolderAndFileSelected = ['download', 'share']
    if (folderCount > 0 && fileCount > 0) {
      return buttonOption.filter(function (button) {
        return !removeBtnForFolderAndFileSelected.includes(button.key)
      })
    }
    return buttonOption
  }

  treeViewFolderClick = (folder) => {
    const { user, userPermission } = this.props

    this.setState({ searchQuery: {} })
    this.onFolderNameClick(
      folder,
      checkUserPermissionForSharedFolder(folder, user, userPermission),
    )
  }

  onFolderNameClick = (folder, permission) => {
    const { baseFolder } = this.props
    this.setState({
      selectedItem: '',
      errorMsg: { msg: '', status: 'success' },
      previousBaseFolder: baseFolder,
      multipleSelectItems: [],
    })
    /* Set Folder name in URL*/
    this.setURLPath(false, folder)
    this.props.handleClearDate()
    this.props.actions.setUserPermissionForFolder(permission)
    this.props.actions.setSelectedFolderToSearch(folder)
    this.removeStateValuesOnFileOperation()
  }

  setURLPath = (isRoot = false, folder = {}) => {
    const path = this.calculateFolderPath(folder)

    if (isRoot) {
      this.props.history.push(`${apiConstants.URLPrefix}`)
    } else {
      this.props.history.push(`${apiConstants.URLPrefix}${path}`)
    }
  }

  downloadFile = (file) => {
    const { user, files } = this.props
    let { itemToDownload, alertBox } = this.state

    caller.trackFPTI(user, ['download'], file)

    const path = this.calculateFilePath(file)
    const url = `${apiConstants.URLPrefix}/${user.accType}/${user.username}/path/${path}`

    itemToDownload.push(file.path)
    if (alertBox.status) {
      this.clearAlertBox()
    }
    this.itemRemainingToDownload.push(file.path)
    this.setState({
      showOptions: false,
      selectedItem: '',
      itemToDownload,
      multipleSelectItems: [],
      showButton: false,
      options: [],
    })

    try {
      const link = document.createElement('a')
      link.href = removeTrailingSlashes(url)
      link.setAttribute('download', this.getSharedFileName(file))
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(link.href)
      link.parentNode.removeChild(link)
    } catch (err) {
      this.onDownloadFailure(files, file, 'failure', err)
    } finally {
      const itemRemaining = this.itemRemainingToDownload.filter(
        (x) => x !== file.path,
      )
      this.setState({ itemToDownload: itemRemaining })
      this.itemRemainingToDownload = itemRemaining
    }
  }

  getSharedFileName = (item) => {
    const fileNameAsArray = item.fileName.split(' ')
    const isShared =
      _.last(fileNameAsArray) === `(${_.get(item, 'sharedBy', '')})`
    if (item.baseFolder === '/' && _.has(item, 'sharedBy') && isShared) {
      return _.join(_.take(fileNameAsArray, fileNameAsArray.length - 1), ' ')
    }
    return item.fileName
  }

  onDownloadFailure = (files, item, status, err) => {
    let msg = ''
    const text = JSON.parse(err.response.text)
    if (text && text.details && text.details.length > 0) {
      msg = text.details[0].description
    } else {
      msg = 'Something went wrong. Try later'
    }
    files.results.forEach((file) => {
      if (
        file.baseFolder === item.baseFolder &&
        file.fileName === item.fileName
      ) {
        file.status = status
        file.msg = msg
      }
    })
    this.props.actions.setFileDetails(files)
  }

  renameFile = (item, renameStatus) => {
    this.setState({
      hasFileToRename: renameStatus,
      fileToRename: item,
      showOptions: false,
      selectedItem: '',
    })
  }

  checkForOperation = (item, options, type, value) => {
    if (item.isShared && options === type) {
      if (type === 'Un Share') {
        this.constructUnShareAlertMessage(item, value, type)
      } else {
        this.constructSharedFileOrFolderAlertMessage(item, options, value)
      }
    } else if (type === 'Un Share With Me') {
      this.constructUnShareAlertMessage(item, value, type)
    } else if (type === 'Rename') {
      this.renameFile(item, true)
    } else if (type === 'Move to') {
      this.cutFile(item, value)
    } else if (type === 'Copy to') {
      this.copyFile(item, value)
    } else if (type === 'Delete') {
      let warningMsg = ''
      if (_.has(item, 'fileName')) {
        warningMsg = getLocalizedContent(
          isFile(_.get(item, 'fileType', ''))
            ? 'alert.delete.file'
            : 'alert.delete.folder',
        )
      }
      this.displayAlertBox(
        item,
        'delete',
        [
          warningMsg === ''
            ? getLocalizedContent('alert.delete.files')
            : warningMsg,
          getLocalizedContent('alert.delete.fileOrFolder.text'),
        ],
        true,
        'warning',
      )
    }
  }

  constructSharedFileOrFolderAlertMessage = (item, options, value) => {
    this.displayAlertBox(
      item,
      '',
      [
        options === 'Delete'
          ? getLocalizedContent(
              `alert.${value}.shared.${item.fileType}.without.name`,
            )
          : getLocalizedContent(
              `alert.${value}.shared.${item.fileType}.with.name`,
              item.fileName,
            ),
      ],
      true,
      'warning',
    )
  }

  constructUnShareAlertMessage = (item, value, type) => {
    this.displayAlertBox(
      item,
      value,
      [
        getLocalizedContent(`alert.unshare.${item.fileType}`, item.fileName),
        type === 'Un Share With Me'
          ? getLocalizedContent('alert.delete.fileOrFolder.text')
          : getLocalizedContent('alert.unshare.fileOrFolder.text'),
      ],
      true,
      'warning',
    )
  }

  rename = (name) => {
    const { fileToRename } = this.state
    const newName = name.trim()
    if (fileToRename.fileName === newName) {
      this.renameFile({}, false)
    } else {
      const isNameAlreadyExists = this.checkIfNameAlreadyExists(newName)
      if (isNameAlreadyExists) {
        this.displayAlertBox(
          {},
          'rename',
          [getLocalizedContent('alert.create.folder', newName)],
          true,
          'warning',
        )
      } else {
        this.initiateFileOrFolderRename(newName)
      }
    }
  }

  checkIfNameAlreadyExists = (newName) => {
    const { fileList } = this.props
    const fileMatch = fileList.results.some((file) => {
      return file.fileName === newName
    })
    return fileMatch
  }

  initiateFileOrFolderRename = (newName) => {
    const { fileToRename } = this.state
    const validateMsg = validateFolderName(newName, fileToRename.fileType)

    if (fileToRename.fileName === newName) {
      this.setState({
        renameIsInProgress: false,
        hasFileToRename: false,
        fileToRename: {},
      })
    } else if (newName !== '' && validateMsg === '') {
      this.setState({
        renameIsInProgress: true,
      })

      const sourcePath = this.calculateFilePath(fileToRename)
      const destinationPath = `${fileToRename.baseFolder}/${newName}`

      this.moveOrRename(
        sourcePath,
        destinationPath,
        fileToRename,
        'rename',
        newName,
      )
    } else if (newName !== '') {
      this.updateErrorMessage(validateMsg)
    }
  }

  restructureList = (type, file, newFile = '') => {
    if (type === 'move') {
      if (file.fileType === 'folder') {
        this.triggerTreeViewFetch()
      }
      this.removeMovedFileOrFolder(file)
    } else if (type === 'rename') {
      if (file.fileType === 'folder') {
        this.triggerTreeViewFetch()
      }
      this.renameFileOrFolder(file, newFile)
      this.setState({
        renameIsInProgress: false,
        hasFileToRename: false,
        fileToRename: {},
      })
    }
  }

  removeMovedFileOrFolder = (file) => {
    const { files, fileList } = this.props
    if (files.results.length > 0) {
      let filtered = files.results.filter(function (value) {
        return value.path !== file.path
      })
      files.results = filtered
    }
    if (fileList.results.length > 0) {
      let filtered = fileList.results.filter(function (value) {
        return value.path !== file.path
      })
      fileList.results = filtered
    }
    files.total = files.results.length
    fileList.total = fileList.results.length
    this.props.actions.setFileDetails(files)
    this.props.actions.setFileListFromResponse(fileList)
  }

  renameFileOrFolder = (file, newFile) => {
    const { files, fileList } = this.props
    if (files.results.length > 0) {
      let filtered = files.results.filter(function (value) {
        if (value.path === file.path) {
          let filename = value.fileName
          value.fileName = newFile
          let path = removeExtraSlashes(file.path).split('/')
          if (path[path.length - 1] === filename) {
            path[path.length - 1] = newFile
            value.path = path.join('/')
          }
        }
        return value
      })
      files.results = filtered
    }
    if (fileList.results.length > 0) {
      let filtered = fileList.results.filter(function (value) {
        if (value.path === file.path) {
          let filename = value.fileName
          value.fileName = newFile
          let path = removeExtraSlashes(file.path).split('/')
          if (path[path.length - 1] === filename) {
            path[path.length - 1] = newFile
            value.path = path.join('/')
          }
        }
        return value
      })
      fileList.results = filtered
    }
    files.total = files.results.length
    fileList.total = fileList.results.length
    this.props.actions.setFileDetails(files)
    this.props.actions.setFileListFromResponse(fileList)
  }

  triggerTreeViewFetch = () => {
    this.props.triggerTreeViewFetch(apiConstants.Root, 'views', true)
  }

  moveOrRename = async (
    source,
    destination,
    fileToRemove,
    type = '',
    newFile = '',
  ) => {
    this.updateMoreOrRenameOrCopyStatusBeforeRequest(
      type === '' ? 'move' : type,
      fileToRemove.fileType,
      source,
      destination,
    )

    const moreOrRenameResponse = await moveOrRenameFileOrFolder(
      source,
      destination,
    )

    if (moreOrRenameResponse.status === 200) {
      this.updateMoreOrRenameSuccessResponse(type, fileToRemove, newFile)
    } else {
      this.updateMoreOrRenameErrorResponse(
        moreOrRenameResponse,
        type,
        fileToRemove,
      )
    }
  }

  updateMoreOrRenameOrCopyStatusBeforeRequest = (
    action,
    fileType,
    sourcePath,
    destinationPath,
  ) => {
    this.updateInfoMessage(
      <Message
        id={`info.${fileType}.${action}.attention`}
        sourcePath={removeExtraSlashes(sourcePath)}
        destinationPath={removeExtraSlashes(destinationPath)}
      />,
    )
    this.setState({
      multipleSelectItems: [],
      showButton: false,
      options: [],
    })
  }

  updateMoreOrRenameSuccessResponse = (type, fileToRemove, newFile) => {
    this.restructureList(type === '' ? 'move' : type, fileToRemove, newFile)
    this.updateSuccessMessage(
      getLocalizedContent(`success.${type === '' ? 'move' : type}`),
    )
  }

  updateMoreOrRenameErrorResponse = (err, type, fileToRemove) => {
    this.setState({
      renameIsInProgress: false,
      hasFileToRename: false,
      fileToRename: {},
    })
    this.constructErrorMessage(err, fileToRemove, type === '' ? 'move' : type)
  }

  cutFile = (item) => {
    const { baseFolder, fileList } = this.props
    this.setState(
      {
        showMoveOrCopyToList: true,
        itemToMove: item,
        hasItemToMove: true,
        itemToCopy: {},
        hasItemToCopy: false,
      },
      () => {
        if (baseFolder === '/') {
          this.setState({
            moveOrCopyFolderDetails: this.removeSelectedFile('Move', fileList),
          })
        } else {
          this.fetchSearchDataForMoveCopy('_fv_root', 'Move')
        }
      },
    )
  }

  copyFile = (item) => {
    const { baseFolder, fileList } = this.props

    this.setState(
      {
        showMoveOrCopyToList: true,
        itemToCopy: item,
        hasItemToCopy: true,
        itemToMove: {},
        hasItemToMove: false,
      },
      () => {
        if (baseFolder === '/') {
          this.setState({
            moveOrCopyFolderDetails: this.removeSelectedFile('Copy', fileList),
          })
        } else {
          this.fetchSearchDataForMoveCopy('_fv_root', 'Copy')
        }
      },
    )
  }

  removeSelectedFile = (type, allFiles) => {
    const { itemToMove, itemToCopy } = this.state
    let item = type === 'Move' ? itemToMove : itemToCopy
    let fileList = []
    if (item.hasOwnProperty('path')) {
      fileList = allFiles.results.filter(function (value) {
        return value.path !== item.path
      })
    } else {
      item.map((file) => {
        fileList = allFiles.results.filter(function (fileItem) {
          return file.path !== fileItem.path
        })
      })
    }
    fileList = fileList.filter((file) =>
      file.permission
        ? file.permission ===
            shareConstants.FilePermissionToServer.readWriteExecute ||
          file.permission === shareConstants.FilePermissionToServer.readWrite
        : true,
    )
    return fileList
  }

  pasteMultipleFile = (destinationFolder) => {
    const { itemToMove, itemToCopy } = this.state

    if (itemToMove.length > 0) {
      if (destinationFolder.fileType === 'folder') {
        itemToMove.map((file) => {
          const destination = `${destinationFolder.path}/${file.fileName}`

          this.moveOrRename(file.path, destination, file, '', '')
        })
      }
    }
    if (itemToCopy.length > 0) {
      if (destinationFolder.fileType === 'folder') {
        itemToCopy.map((file) => {
          const destination = `${destinationFolder.path}/${file.fileName}`

          this.copyFiles(file.path, destination, file)
        })
      }
    }
  }

  pasteFile = (destinationFolder) => {
    const { itemToMove, itemToCopy } = this.state

    if (itemToMove.fileName) {
      if (destinationFolder.fileType === 'folder') {
        let destination = `${destinationFolder.path}/${itemToMove.fileName}`
        this.moveOrRename(itemToMove.path, destination, itemToMove, '', '')
      }
    }
    if (itemToCopy.fileName) {
      if (destinationFolder.fileType === 'folder') {
        let destination = `${destinationFolder.path}/${itemToCopy.fileName}`

        this.copyFiles(itemToCopy.path, destination, itemToCopy)
      }
    }
    this.setState({
      itemToMove: {},
      hasItemToMove: false,
      itemToCopy: {},
      hasItemToCopy: false,
      showOptions: false,
      selectedItem: '',
    })
  }

  fetchSearchDataForMoveCopy = async (path, type) => {
    const params = { fileType: 'folder' }
    this.updateStateValueOnFetchFolderListForMoveOrCopy([], true)
    const searchResponse = await fetchFolderData(path, params)
    if (searchResponse.status === 200) {
      this.updateFolderListForMoveOrCopySuccessResponse(searchResponse, type)
    } else {
      this.updateStateValueOnFetchFolderListForMoveOrCopy([], false)
    }
  }

  updateFolderListForMoveOrCopySuccessResponse = (response, type) => {
    const folderList = JSON.parse(response.text)
    const files = this.removeSelectedFile(type, folderList)
    this.updateStateValueOnFetchFolderListForMoveOrCopy(files, false)
  }

  updateStateValueOnFetchFolderListForMoveOrCopy = (
    moveOrCopyFolderDetails,
    folderListFetchInProgress,
  ) => {
    this.setState({
      moveOrCopyFolderDetails,
      folderListFetchInProgress,
    })
  }

  renderOptionsList = () => {
    this.setState({
      itemToMove: {},
      hasItemToMove: false,
      itemToCopy: {},
      hasItemToCopy: false,
    })
  }

  copyFiles = async (source, destination, file) => {
    this.updateMoreOrRenameOrCopyStatusBeforeRequest(
      'copy',
      file.fileType,
      source,
      destination,
    )
    const copyResponse = await copyFileOrFolder(source, destination)

    if (copyResponse.status === 200) {
      this.updateCopySuccessResponse(file)
    } else {
      this.constructErrorMessage(copyResponse, file, 'copy')
    }
  }

  updateCopySuccessResponse = (file) => {
    if (file.fileType === 'folder') {
      this.triggerTreeViewFetch()
    }
    this.updateSuccessMessage(getLocalizedContent('success.copy'))
  }

  displayAlertBox = (item, action, msg, status, type) => {
    this.setState({
      showOptions: false,
      alertBox: {
        type,
        status,
        msg,
        action: this.renderAction(action),
        for: item,
      },
    })
  }

  renderAction = (action) => {
    if (action === 'refresh' || action === 'login') {
      return [action]
    }
    if (action === '') {
      return ['cancel']
    }
    if (action === 'upload') {
      return ['no', 'yes']
    }
    if (action === 'uploadSharedFile') {
      return ['cancelUpload']
    }
    if (action === 'rename') {
      return ['cancelRename']
    }
    return ['cancel', action]
  }

  renderLocalizedAction = (action) => {
    if (action === 'refresh' || action === 'login') {
      return getLocalizedContent('buttons.refresh')
    }
    if (
      action === '' ||
      action === 'uploadSharedFile' ||
      action === 'rename' ||
      action === 'cancelRename' ||
      action === 'cancelUpload'
    ) {
      return getLocalizedContent('buttons.cancel')
    }
    return getLocalizedContent(`buttons.${action}`)
  }

  checkAlertBoxAction = (item, type) => {
    if (type === 'delete') {
      this.clearAlertBox()
      this.deleteFiles(item)
    } else if (type === 'cancel') {
      this.clearAlertBox()
    } else if (type === 'download') {
      this.downloadFile(item)
    } else if (type === 'refresh' || type === 'login') {
      window.location.href = `${apiConstants.URLPrefix}`
    } else if (type === 'yes') {
      this.updateFileStatusForUpload(item, true)
      this.removeFileSelectedToUpload()
    } else if (type === 'no' || type === 'cancelUpload') {
      this.removeFileSelectedToUpload()
    } else if (type === 'unshare') {
      this.clearAlertBox()
      this.unShareFileOrFolder(item)
    } else if (type === 'cancelRename') {
      this.clearAlertBox()
      this.renameFile({}, false)
    }
  }

  unShareFileOrFolder = async (item) => {
    const { itemToUnshare } = this.state

    itemToUnshare.push(item.path)

    this.setState({ itemToUnshare })
    this.updateInfoMessage(
      <Message
        id={`info.${item.fileType}.unshare.attention`}
        filename={item.fileName}
      />,
    )

    const deleteShareeResponse = await fetchOrUpdateShareeDetails(
      'DELETE',
      item.path,
      '',
    )
    if (deleteShareeResponse.status === 200) {
      this.updateSuccessMessage(
        getLocalizedContent(`success.${item.fileType}.unshare`),
      )
      this.updateFileListAfterSharing(item)
    } else {
      this.constructErrorMessage(deleteShareeResponse, item)
    }
    const itemRemaining = itemToUnshare.filter((x) => x !== item.path)
    this.setState({ itemToUnshare: itemRemaining })
  }

  updateFileListAfterSharing = (item) => {
    const { files, fileList } = this.props
    let fileListAfterSharing,
      filesListAfterSharing = {}
    if (_.has(item, 'sharedBy', false)) {
      fileListAfterSharing = fileList.results.filter(function (file) {
        return removeExtraSlashes(file.path) !== removeExtraSlashes(item.path)
      })
    } else {
      fileListAfterSharing = fileList.results.map((file) =>
        item.path.includes(file.path)
          ? {
              ...file,
              isShared: false,
              shareNotificationStatus: {},
            }
          : file,
      )
    }
    this.props.actions.setFileListFromResponse({
      total: fileListAfterSharing.length,
      results: fileListAfterSharing,
    })
    if (_.has(item, 'sharedBy', false)) {
      filesListAfterSharing = files.results.filter(function (file) {
        return removeExtraSlashes(file.path) !== removeExtraSlashes(item.path)
      })
    } else {
      filesListAfterSharing = files.results.map((file) =>
        item.path.includes(file.path)
          ? {
              ...file,
              isShared: false,
              shareNotificationStatus: {},
            }
          : file,
      )
    }
    this.props.actions.setFileDetails({
      total: filesListAfterSharing.length,
      results: filesListAfterSharing,
    })
  }

  updateFileStatusForUpload = (file, replace) => {
    file.status = 'uploading'
    file.progress = 0
    file.msg = ''
    this.uploadFile(file, replace)
  }

  removeFileSelectedToUpload = () => {
    const {
      filesToBeVerifiedFromUserBeforeUpload,
      displayingAlertBoxForFile,
    } = this.state
    this.clearAlertBox()
    const files = filesToBeVerifiedFromUserBeforeUpload.filter(
      (item) => _.get(displayingAlertBoxForFile, 'file.name') !== item.name,
    )
    if (files.length > 0) {
      this.setState({
        filesToBeVerifiedFromUserBeforeUpload: files,
        displayingAlertBoxForFile: { file: files[0], index: 0 },
      })
    } else {
      this.setState({
        filesToBeVerifiedFromUserBeforeUpload: files,
        displayingAlertBoxForFile: {},
      })
    }
  }

  clearAlertBox = () => {
    this.setState({
      alertBox: {
        status: false,
        msg: '',
        sec_msg: '',
        action: [],
        for: {},
      },
    })
  }

  deleteFiles = (item) => {
    if (item.hasOwnProperty('fileName')) {
      this.deleteFile(item)
    }
    if (item.length > 0) {
      this.deleteMultipleFile(item)
    }
  }

  onOptionsClick = (item, options) => {
    const { user, userPermission } = this.props
    switch (options) {
      case 'Open':
        if (item.fileType === 'folder') {
          caller.trackFPTI(user, ['search'], item)
          this.props.actions.setSelectedFolderToSearch(item)
          this.onFolderNameClick(
            item,
            checkUserPermissionForSharedFolder(item, user, userPermission),
          )
        } else {
          this.downloadFile(item)
        }
        break
      case 'Delete':
        this.checkForOperation(item, options, 'Delete', 'delete')
        break
      case 'Move to':
        this.checkForOperation(item, options, 'Move to', 'move')
        break
      case 'Copy to':
        this.checkForOperation(item, options, 'Copy to', 'copy')
        break
      case 'Download':
        this.downloadFile(item)
        break
      case 'Rename':
        this.checkForOperation(item, options, 'Rename', 'rename')
        break
      case 'Share':
        this.props.setShareBoxVisibility(true, item)
        break
      case 'Un Share':
        this.checkForOperation(item, options, 'Un Share', 'unshare')
        break
      case 'Un Share With Me':
        this.checkForOperation(item, options, 'Un Share With Me', 'unshare')
        break
      case 'Details':
        this.setState({
          showProperties: true,
          showPropertiesForItem: item,
          showOptions: false,
        })
        break
      case 'Delivery status':
        caller.trackFPTI(user, ['deliveryStatus'], item)
        this.fetchDeliveryStatusOfFileOrFolder(item)
        break
      case 'File History':
        this.setState({
          showFileHistory: true,
          showFileHistoryForItem: item,
          showOptions: false,
        })
        break
      default:
        this.setState({ selectedItem: '', showOptions: false })
        break
    }
  }

  fetchDeliveryStatusOfFileOrFolder = async (file) => {
    file.shareNotificationStatus = {}
    this.updateStateValuesForDeliveryStatus(true, true, {
      msg: '',
      status: 'success',
    })
    this.setState({
      showOptions: false,
      selectedItemToViewDeliveryStatus: file,
    })

    const metaDataResponse = await fetchMetaDataOfFileOrFolder(file.path)

    if (metaDataResponse.status === 200) {
      this.updateDeliveryStatusSuccessResponse(metaDataResponse)
    } else {
      this.updateDeliveryStatusErrorResponse(metaDataResponse, file)
    }
  }

  updateDeliveryStatusSuccessResponse = (response) => {
    const result = _.get(JSON.parse(response.text), 'results', [])
    if (result.length === 1) {
      let metaData = result[0]
      if (!_.has(metaData, 'shareNotificationStatus')) {
        metaData.shareNotificationStatus = {}
      }
      this.setState({
        selectedItemToViewDeliveryStatus: metaData,
        fetchDeliveryStatusInProgress: false,
      })
    } else {
      this.updateStateValuesForDeliveryStatus(true, false, {
        msg: errorConstants[404].message,
        status: 'error',
      })
    }
  }

  updateDeliveryStatusErrorResponse = (err, file) => {
    const msg = this.constructErrorMessage(err, file, 'deliveryStatus', false)
      .msg
    this.updateStateValuesForDeliveryStatus(true, false, {
      msg,
      status: 'error',
    })
  }

  updateStateValuesForDeliveryStatus = (
    showDeliveryStatus,
    fetchDeliveryStatusInProgress,
    deliveryStatusErrorMessage,
  ) => {
    this.setState({
      showDeliveryStatus,
      fetchDeliveryStatusInProgress,
      deliveryStatusErrorMessage,
    })
  }

  deleteFile = async (item) => {
    const path = this.calculateFilePath(item)
    const itemToDelete = this.updateItemToDelete(path)
    this.updateStateBeforeDeleteFile()

    const deleteResponse = await deleteFileOrFolder(path)
    this.updateDeleteFileOrFolderResponse(deleteResponse, item, path, 'single')
    const itemRemaining = itemToDelete.filter((x) => x !== item.path)
    this.setState({ itemToDelete: itemRemaining })
  }

  deleteMultipleFile = (fileList) => {
    this.updateStateBeforeDeleteFile()

    if (fileList.length > 0) {
      let deleted = 0
      this.setState({
        showButton: false,
        options: [],
        multipleSelectItems: [],
      })

      fileList.map(async (file) => {
        const path = this.calculateFilePath(file)
        const itemToDelete = this.updateItemToDelete(path)

        const deleteResponse = await deleteFileOrFolder(path)
        deleted++
        _.pull(itemToDelete, path)
        this.updateDeleteFileOrFolderResponse(
          deleteResponse,
          file,
          path,
          'multiple',
        )
        this.updateMultiFileDeletePostAction(deleted, itemToDelete)
      })
    }
  }

  updateDeleteFileOrFolderResponse = (deleteResponse, file, path, type) => {
    if (deleteResponse.status === 200) {
      this.updateDeleteFileOrFolderSuccessResponse(file, path, type)
    } else {
      this.constructErrorMessage(deleteResponse, file, 'delete')
    }
  }

  updateStateBeforeDeleteFile = () => {
    this.setState({ showOptions: false, selectedItem: '' })
  }

  updateItemToDelete = (path) => {
    let { itemToDelete } = this.state
    itemToDelete.push(path)
    this.setState({ itemToDelete })
    return itemToDelete
  }

  updateMultiFileDeletePostAction = (deleted, itemToDelete) => {
    if (deleted === itemToDelete.length) {
      this.setState({
        itemToDelete: [],
      })
    } else {
      this.setState({ itemToDelete })
    }
  }

  updateDeleteFileOrFolderSuccessResponse = (file, path, type) => {
    const { files } = this.props
    if (file.fileType === 'folder') {
      this.triggerTreeViewFetch()
    }
    this.removeFileOrFolderAfterDelete(files, path, type)
    this.updateSuccessMessage(getLocalizedContent('success.delete'))
  }

  removeFileOrFolderAfterDelete = (files, path, type) => {
    const { fileList, folderList } = this.props
    if (files.results.length > 0) {
      let filtered = files.results.filter(function (value) {
        return value.path !== path
      })
      files.results = filtered
      files.total = files.results.length
    }
    if (fileList.results.length > 0) {
      let filtered = fileList.results.filter(function (value) {
        return value.path !== path
      })
      fileList.results = filtered
      fileList.total = fileList.results.length
    }
    if (folderList.results.length > 0) {
      let filtered = folderList.results.filter(function (value) {
        return value.path !== path
      })
      folderList.results = filtered
      folderList.total = folderList.results.length
    }
    this.props.actions.setFileDetails(files)
    this.props.actions.setFileListFromResponse(fileList)
    this.props.actions.setTree(folderList)
    if (type === 'single') {
      if (files.results.length === 0) {
        this.setState({
          showButton: false,
          options: [],
          multipleSelectItems: [],
        })
      }
    }
  }

  isUploadFileNotAllowed = () => {
    const { user, baseFolder, userPermission } = this.props
    return (
      (user.accType === constants.AdhocUser && baseFolder === '/') ||
      userPermission === shareConstants.FilePermissions.list ||
      userPermission === shareConstants.FilePermissions.read
    )
  }

  onUploadFilesClick = (selectedFilesToUpload) => {
    if (this.isUploadFileNotAllowed()) {
      this.updateErrorMessage('error.no.permission')
    } else {
      this.setState({ renderUploadFile: true })
      let filesToUpload = []
      if (selectedFilesToUpload.length > 0) {
        selectedFilesToUpload = this.validateFileOnDragAndDrop(
          selectedFilesToUpload,
        )
        filesToUpload = this.updateUploadFilesPath(selectedFilesToUpload)
        this.validateFileBeforeUpload(filesToUpload)
      }
    }
  }

  validateFileOnDragAndDrop = (filesToUpload) => {
    const validateResult = this.validateSelectedFilesToUpload(filesToUpload)

    if (validateResult.improperFilesErrMsg !== '') {
      this.updateErrorMessage(validateResult.improperFilesErrMsg)
    }
    if (validateResult.dotFilesErrMsg !== '') {
      this.updateErrorMessage(validateResult.dotFilesErrMsg)
    }
    if (validateResult.folderNotAllowedErrMsg !== '') {
      this.updateErrorMessage(validateResult.folderNotAllowedErrMsg)
    }

    return validateResult.allowedFile
  }

  validateSelectedFilesToUpload = (filesToUpload) => {
    const [notProperFiles, properFiles] = _.partition(filesToUpload, (file) => {
      return isNotProperFileName(file.name)
    })
    const [notAllowedFile, allowedFile] = _.partition(properFiles, function (
      file,
    ) {
      return (
        file.name.startsWith('.') ||
        (_.has(file, 'path') &&
          file.path &&
          removeExtraSlashes(file.path).split('/').length > 1)
      )
    })
    const [selectedDotFiles, selectedFolders] = _.partition(
      notAllowedFile,
      (file) => {
        return file.name.startsWith('.')
      },
    )

    return {
      improperFilesErrMsg: constructUploadFileErrorMessage(
        notProperFiles,
        [],
        [],
      ),
      dotFilesErrMsg: constructUploadFileErrorMessage([], selectedDotFiles, []),
      folderNotAllowedErrMsg: constructUploadFileErrorMessage(
        [],
        [],
        selectedFolders,
      ),
      allowedFile,
    }
  }

  validateFileBeforeUpload = (selectedFilesToUpload) => {
    const { fileList, filesToUpload } = this.props
    const { filesToBeVerifiedFromUserBeforeUpload } = this.state
    const verifiedFileToUpload = this.removeDuplicateFiles(
      selectedFilesToUpload,
      filesToUpload,
    )

    if (verifiedFileToUpload.length > 0) {
      const [existingFileListToUpload, newFilesListToUpload] = _.partition(
        verifiedFileToUpload,
        function (file) {
          const checkedFile = fileList.results.filter((fileFromList) => {
            return (
              removeExtraSlashes(fileFromList.path) ===
              removeExtraSlashes(`${file.basePath}/${file.name}`)
            )
          })
          return checkedFile.length === 1
        },
      )

      const verifiedExistingFileToUpload = _.difference(
        existingFileListToUpload,
        filesToBeVerifiedFromUserBeforeUpload,
      )

      if (verifiedExistingFileToUpload.length > 0) {
        this.setState({
          filesToBeVerifiedFromUserBeforeUpload: verifiedExistingFileToUpload,
          displayingAlertBoxForFile: {
            file: verifiedExistingFileToUpload[0],
            index: 0,
          },
        })
        this.displayAlertForUpload(verifiedExistingFileToUpload[0])
      }

      const verifiedNewFileList = this.removeDuplicateFiles(
        newFilesListToUpload,
        filesToUpload,
      )

      if (verifiedNewFileList.length > 0) {
        /*eslint-disable */
        verifiedNewFileList.map((item) => {
          item.basePath,
            item.lastModified,
            item.lastModifiedDate,
            item.name,
            item.path,
            item.size,
            item.type,
            item.webkitRelativePath,
            (item.status = 'uploading'),
            (item.progress = 0),
            (item.msg = ''),
            this.uploadFile(item)
        })
        /*eslint-enable */
      }
    }
  }

  displayAlertForUpload = (file) => {
    const { fileList } = this.props
    const actualFileDetails = fileList.results.filter((fileFromList) => {
      return (
        removeExtraSlashes(fileFromList.path) ===
        removeExtraSlashes(`${file.basePath}/${file.name}`)
      )
    })
    if (_.get(actualFileDetails[0], 'isShared', false)) {
      this.displayAlertBox(
        file,
        'uploadSharedFile',
        [getLocalizedContent('alert.replace.shared.file', file.name)],
        true,
        'warning',
      )
    } else {
      this.displayAlertBox(
        file,
        'upload',
        [getLocalizedContent('alert.upload.existing', file.name)],
        true,
        'warning',
      )
    }
  }

  uploadFile = (file, replace = false) => {
    const { user, filesToUpload } = this.props

    filesToUpload.push(file)
    this.props.actions.setFilesToUpload(filesToUpload)
    this.setState({ renderUploadFile: false })
    const path = removeExtraSlashes(`${file.basePath}/${file.name}`)
    const url = `${apiConstants.URLPrefix}/${user.accType}/${user.username}/path/${path}`
    caller
      .singleUpload(url, file, replace)
      .on('progress', (e) => {
        this.setState({ renderUploadFile: true })
        this.props.actions.setFileUploadProgress(file, e.percent)
      })
      .then(() => {
        this.onUploadSuccess(file, 'success', 'Upload Success')
        this.removeFilesOnUploadSuccess(file)
        return
      })
      .catch((err) => {
        this.onFailure(file, 'failure', err)
      })
  }

  onUploadSuccess = (item, status, msg) => {
    const { baseFolder, files, fileList, selectedFolderToSearch } = this.props
    const today = new Date()
    const date = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`

    const newFile = {
      baseFolder: `${item.basePath}`,
      createdDate: date,
      fileName: item.name,
      fileType: 'file',
      isShared: false,
      modifiedDate: date,
      path:
        baseFolder === '/' ? `/${item.name}` : `${item.basePath}/${item.name}`,
      size: item.size,
      status,
      msg,
    }

    const newFilesInfo = {
      ...newFile,
      ..._.pick(selectedFolderToSearch, shareConstants.NeededShareeDetails),
    }

    if (files.results) {
      let filesResult = files.results.filter((file) => {
        return (
          item.name !== file.name &&
          removeExtraSlashes(`${item.basePath}/${item.name}`) !==
            removeExtraSlashes(file.path)
        )
      })
      filesResult.unshift(newFilesInfo)
      files.results = filesResult
    } else {
      files.results = [newFilesInfo]
    }
    files.total = files.results.length
    if (fileList.results) {
      let fileListResult = fileList.results.filter((file) => {
        return (
          item.name !== file.name &&
          removeExtraSlashes(`${item.basePath}/${item.name}`) !==
            removeExtraSlashes(file.path)
        )
      })
      fileListResult.unshift(newFilesInfo)
      fileList.results = fileListResult
    } else {
      fileList.results = [newFilesInfo]
    }
    fileList.total = fileList.results.length
    this.props.actions.setFileListFromResponse(fileList)
    this.props.actions.setFileDetails(files)
  }

  removeFilesOnUploadSuccess = (file) => {
    let { filesToUpload } = this.props

    _.remove(filesToUpload, function (files) {
      return (
        files.name === file.name &&
        removeExtraSlashes(`${files.basePath}/${files.name}`) ===
          removeExtraSlashes(`${file.basePath}/${file.name}`)
      )
    })
    this.props.actions.setFilesToUpload(filesToUpload)
    this.setState({ renderUploadFile: false })
  }

  onFailure = (item, status, error) => {
    const { filesToUpload } = this.props
    if (error.status && error.status === 409) {
      const remainingFiles = filesToUpload.filter(
        (e) =>
          e.name !== item.name &&
          removeExtraSlashes(`${e.basePath}/${e.name}`) !==
            removeExtraSlashes(`${item.basePath}/${item.name}`),
      )
      this.displayAlertBox(
        item,
        'upload',
        [getLocalizedContent('alert.upload.existing', item.name)],
        true,
        'warning',
      )
      this.props.actions.setFilesToUpload(remainingFiles)
    } else {
      filesToUpload.map((file) => {
        if (file.basePath === item.basePath && file.name === item.name) {
          file.status = status
          if (status === 'success') {
            file.msg = error
          } else if (typeof error === 'string') {
            file.msg = error
          } else {
            file.msg = this.constructErrorMessage(
              error,
              file,
              'upload',
              false,
            ).msg
          }
        }
      })
      this.props.actions.setFilesToUpload(filesToUpload)
    }
  }

  removeDuplicateFiles = (newFiles, currentFiles) => {
    return newFiles.filter(function (file1) {
      return !currentFiles.some(function (file2) {
        return (
          file1.name === file2.name &&
          removeExtraSlashes(`${file1.basePath}/${file1.name}`) ===
            removeExtraSlashes(`${file2.basePath}/${file2.name}`)
        )
      })
    })
  }

  updateUploadFilesPath = (selectedFilesToUpload) => {
    const { baseFolder, filesToUpload } = this.props
    selectedFilesToUpload.map((item) => {
      item.basePath = baseFolder
    })
    return this.removeDuplicateFiles(selectedFilesToUpload, filesToUpload)
  }

  constructErrorMessage = (
    error,
    file = {},
    operation,
    isMsgToBeUpdated = true,
  ) => {
    if (!error.status || !_.get(error, 'status')) {
      this.displayAlertBox(
        {},
        'refresh',
        [getLocalizedContent('error.session.expired')],
        true,
        'warning',
      )
      return false
    }
    if (error.status === 401) {
      this.displayAlertBox(
        {},
        'login',
        [getLocalizedContent('error.access.denied')],
        true,
        'warning',
      )
    }
    const errorMsg = {
      msg: getErrorMessage(error, file, operation),
      status: 'error',
    }
    if (isMsgToBeUpdated) {
      this.updateErrorMessage(errorMsg.msg)
    }
    return errorMsg
  }

  updateErrorMessage = (msg) => {
    this.setState({
      errorMsg: { msg, status: 'error' },
    })
  }

  updateSuccessMessage = (msg) => {
    this.setState({
      errorMsg: { msg, status: 'success' },
    })
  }

  updateInfoMessage = (msg) => {
    this.setState({
      errorMsg: { msg, status: 'info' },
    })
  }

  setSharedDetailsInfo = (item) => {
    const { baseFolder } = this.props
    const { isPathFromURLRedirect } = this.state

    if (
      (baseFolder === '/' || isPathFromURLRedirect) &&
      _.has(item, 'sharedBy')
    ) {
      let sharedInfo = {}
      sharedInfo.sharedBy = item.sharedBy
      sharedInfo.permission = item.permission
        ? item.permission
        : shareConstants.DefaultPermissions.permission
      sharedInfo.enableNotifications = item.enableNotifications
      sharedInfo.showCollaborators = item.showCollaborators
      sharedInfo.enableOwnerNotifications = item.enableOwnerNotifications

      this.props.actions.setSharedFolderDetails(sharedInfo)
    }
  }

  calculateFolderPath = (item) => {
    this.setSharedDetailsInfo(item.hasOwnProperty('sharedBy') ? item : {})
    this.props.setBaseFolder(_.get(item, 'path', ''))
    return _.get(item, 'path', '')
  }

  calculateFilePath = (item) => {
    return item.path
  }

  captureDoubleClick = (item) => {
    const { user, userPermission } = this.props
    if (item.fileType === 'folder') {
      this.props.actions.setSelectedFolderToSearch(item)
      this.onFolderNameClick(
        item,
        checkUserPermissionForSharedFolder(item, user, userPermission),
      )
    } else if (item.fileType === 'file') {
      this.downloadFile(item)
    }
  }

  onBreadCrumbsRootParentClick = () => {
    const { searchQuery } = this.state
    const { user, baseFolder } = this.props

    this.props.actions.setSharedFolderDetails({})
    this.props.actions.setSelectedFolderToSearch({})
    this.props.actions.setUserPermissionForFolder(
      isCorpOrGoPayUser(user)
        ? shareConstants.FilePermissions.readWriteExecute
        : shareConstants.FilePermissions.readWrite,
    )
    if (!_.has(searchQuery, 'quickSearch')) {
      this.props.clearSearchField()
      this.props.actions.setBaseFolder('/', () => {
        this.onFilterChange({ quickSearch: searchQuery.quickSearch })
      })
    } else {
      this.props.actions.setBaseFolder('/')
      this.onFilterChange({ quickSearch: searchQuery.quickSearch })
      this.constructFetchQuery(apiConstants.Root, true)
    }
    this.setState({ previousBaseFolder: baseFolder, multipleSelectItems: [] })
    this.setURLPath(true)
    this.props.handleClearDate()
  }

  setPreviousBaseFolder = (baseFolder) => {
    this.setState({
      previousBaseFolder: baseFolder,
      multipleSelectItems: [],
      isBreadCrumbClick: true,
    })
  }

  onFilterChange = (searchQuery) => {
    this.props.clearSearchField()
    this.setState({
      searchQuery,
      advnFilterBoxPosition: [],
      showAdvnFilterBox: false,
    })
  }

  closePropertyBox = () => {
    this.setState({
      selectedItem: '',
      showProperties: false,
      showPropertiesForItem: {},
    })
  }

  closeDeliveryStatusBox = () => {
    this.setState({
      selectedItem: '',
      showDeliveryStatus: false,
      fetchDeliveryStatusInProgress: false,
      deliveryStatusErrorMessage: { msg: '', status: 'success' },
      selectedItemToViewDeliveryStatus: {},
    })
  }

  closeFileHistoryBox = () => {
    this.setState({
      selectedItem: '',
      showFileHistory: false,
      showFileHistoryForItem: {},
    })
  }

  setDeliveryStatus = (selectedItemToViewDeliveryStatus) => {
    this.setState({ selectedItemToViewDeliveryStatus })
  }

  onMouseOver = (e) => {
    const rect = e.target.getBoundingClientRect()
    if (e.target.children[0]) {
      e.target.children[0].style.top = `${rect.top + 20}px`
      e.target.children[0].style.left = `${rect.left - 30}px`
    }
  }

  shareFileForMoreUser = (showShareForItem) => {
    this.props.setShareBoxVisibility(true, showShareForItem)
    this.setState({
      showDeliveryStatus: false,
      fetchDeliveryStatusInProgress: false,
      deliveryStatusErrorMessage: { msg: '', status: 'success' },
      selectedItemToViewDeliveryStatus: {},
    })
  }

  clearAppliedFilter = (key) => {
    const { searchQuery } = this.state
    const newQuery = Object.keys(searchQuery).reduce((object, obJKey) => {
      if (obJKey !== key) {
        object[obJKey] = searchQuery[obJKey]
      }
      return object
    }, {})
    this.onFilterChange(newQuery)
  }

  setAdvnFilterBoxVisibility = (e) => {
    const rect = e.target.getBoundingClientRect()
    this.setState((prevState) => ({
      showAdvnFilterBox: !prevState.showAdvnFilterBox,
      advnFilterBoxPosition: !prevState.showAdvnFilterBox
        ? [rect.top + 40, rect.left - 250]
        : [],
    }))
    this.removeStateValuesOnFileOperation()
  }

  renderButtonList = (selectedItem) => {
    const { files } = this.state
    const fileItem = fileOptionsConstants.FileOptionsOutside.find(function (
      item,
    ) {
      return _.get(files, `results[${selectedItem}].fileType`) === item.type
    })

    return _.get(fileItem, 'options', {})
  }

  getButtons = (buttonsList) => {
    const { user } = this.props
    const buttons = buttonsList.filter(function (button) {
      return button.renderFor.includes(user.accType)
    })
    return buttons
  }

  getDefaultButton = () => {
    let defaultButtons = []
    fileOptionsConstants.FileOptionsOutside.forEach((item) => {
      if (item.type !== 'default') {
        defaultButtons = _.union(defaultButtons, this.getButtons(item.options))
      }
    })

    const uniqButtons = _.uniqBy(defaultButtons, 'option')
    return uniqButtons
  }

  getShareButton = (options) => {
    const { selectedFolderToSearch } = this.props
    let button = []
    if (
      !_.has(selectedFolderToSearch, 'permission') &&
      _.get(selectedFolderToSearch, 'path', '') !== ''
    ) {
      fileOptionsConstants.FileOptionsOutside.map((fileItem) => {
        if (fileItem.type === 'folder') {
          button = fileItem.options.filter((i) => i.option === 'Share')
        }
      })
    }
    return _.uniqBy(_.union(options, button), 'option')
  }

  renderButtons = () => {
    const {
      showButton,
      viewType,
      multipleSelectItems,
      showMoveOrCopyToList,
      moveOrCopyFolderDetails,
      folderListFetchInProgress,
      hasItemToMove,
      hasItemToCopy,
      itemToCopy,
      itemToMove,
    } = this.state
    let { options } = this.state
    const { baseFolder } = this.props
    const defaultButtons = this.getDefaultButton()
    if (multipleSelectItems.length > 0 && options.length === 0) {
      options = this.getButtonOptions(multipleSelectItems, options)
    }
    if (
      baseFolder !== '/' &&
      baseFolder !== '_fv_root' &&
      baseFolder !== '' &&
      multipleSelectItems.length === 0
    ) {
      options = this.getShareButton(options)
    }
    return (
      <Buttons
        {...this.props}
        multipleSelectItems={multipleSelectItems}
        changeView={this.changeView}
        viewType={viewType}
        onOptionsClick={this.onOptionsClick}
        setUploadFileBoxVisibility={this.props.setUploadFileBoxVisibility}
        setCreateNewFolderVisibility={this.setCreateNewFolderVisibility}
        options={options}
        showButton={showButton}
        defaultButtons={defaultButtons}
        hasItemToMove={hasItemToMove}
        hasItemToCopy={hasItemToCopy}
        showMoveOrCopyToList={showMoveOrCopyToList}
        moveOrCopyFolderDetails={moveOrCopyFolderDetails}
        folderListFetchInProgress={folderListFetchInProgress}
        selectedOptionList={this.state.selectedOptionList}
        fetchSearchDataForMoveCopy={this.fetchSearchDataForMoveCopy}
        pasteFile={this.pasteMultipleFile}
        fileOptionStatus={this.fileOptionStatusAdditional}
        itemToCopy={itemToCopy}
        itemToMove={itemToMove}
      />
    )
  }

  renderButtonsAndFilters = () => {
    const { options } = this.state
    return (
      <div
        className={`view__buttons_and_filter-container ${
          options.length === 0 ? 'view__filter_without-button' : ''
        }`}
      >
        {this.renderButtons()}
        {this.renderFilters()}
      </div>
    )
  }

  renderFilters = () => {
    const { searchQuery, advnFilterBoxPosition, showAdvnFilterBox } = this.state
    return (
      <RenderFilters
        {...this.props}
        showAdvnFilterBox={showAdvnFilterBox}
        searchQuery={searchQuery}
        advnFilterBoxPosition={advnFilterBoxPosition}
        advnRef={this.advnRef}
        setAdvnFilterBoxVisibility={this.setAdvnFilterBoxVisibility}
        onFilterChange={this.onFilterChange}
      />
    )
  }

  renderProperties = () => {
    const { showPropertiesForItem } = this.state
    return (
      <RenderProperties
        showPropertiesForItem={showPropertiesForItem}
        closePropertyBox={this.closePropertyBox}
        onMouseOver={this.onMouseOver}
      />
    )
  }

  renderDeliveryProperities = () => {
    const {
      selectedItemToViewDeliveryStatus,
      fetchDeliveryStatusInProgress,
      deliveryStatusErrorMessage,
    } = this.state
    return (
      <EmailDeliveryStatus
        {...this.props}
        selectedItemToViewDeliveryStatus={selectedItemToViewDeliveryStatus}
        setDeliveryStatus={this.setDeliveryStatus}
        closeDeliveryStatusBox={this.closeDeliveryStatusBox}
        sendEmailToUser={this.sendEmailToUser}
        onMouseOver={this.onMouseOver}
        shareFileForMoreUser={this.shareFileForMoreUser}
        fetchDeliveryStatusInProgress={fetchDeliveryStatusInProgress}
        deliveryStatusErrorMessage={deliveryStatusErrorMessage}
        fetchDeliveryStatusOfFileOrFolder={
          this.fetchDeliveryStatusOfFileOrFolder
        }
      />
    )
  }

  renderFileHistory = () => {
    const { showFileHistoryForItem } = this.state
    return (
      <RenderFileHistory
        {...this.props}
        showFileHistoryForItem={showFileHistoryForItem}
        constructErrorMessage={this.constructErrorMessage}
        closeFileHistoryBox={this.closeFileHistoryBox}
        onMouseOver={this.onMouseOver}
      />
    )
  }

  renderGridView = () => {
    const {
      selectedItem,
      showButton,
      files,
      showOptions,
      showCreateFolder,
      isFilesFetchInProgress,
      isCreateFolderInProgress,
    } = this.state
    return (
      <GridView
        {...this.props}
        isCreateFolderInProgress={isCreateFolderInProgress}
        showCreateFolder={showCreateFolder}
        isFilesFetchInProgress={isFilesFetchInProgress}
        capture={this.capture}
        selectedItem={selectedItem}
        files={files}
        showOptions={showOptions}
        showButton={showButton}
        clickItems={this.clickItems}
        fileOptionStatus={this.fileOptionStatus}
        onOptionsClick={this.onOptionsClick}
        captureDoubleClick={this.captureDoubleClick}
      />
    )
  }

  renderListView = () => {
    const {
      selectedItem,
      showButton,
      files,
      showOptions,
      showCreateFolder,
      isFilesFetchInProgress,
      isCreateFolderInProgress,
      fileToRename,
      hasFileToRename,
      renameIsInProgress,
      itemToDelete,
      itemToUnshare,
      multipleSelectItems,
      searchQuery,
      itemToDownload,
      moveOrCopyFolderDetails,
      showMoveOrCopyToList,
      folderListFetchInProgress,
      pageNo,
      itemToMove,
      itemToCopy,
      renderUploadFile,
    } = this.state
    return (
      <ListView
        {...this.props}
        isCreateFolderInProgress={isCreateFolderInProgress}
        showCreateFolder={showCreateFolder}
        isFilesFetchInProgress={isFilesFetchInProgress}
        capture={this.capture}
        selectedItem={selectedItem}
        files={files}
        showOptions={showOptions}
        showButton={showButton}
        clickItems={this.clickItems}
        fileOptionStatus={this.fileOptionStatus}
        onOptionsClick={this.onOptionsClick}
        captureDoubleClick={this.captureDoubleClick}
        moveOrRename={this.moveOrRename}
        fileToRename={fileToRename}
        hasFileToRename={hasFileToRename}
        renameIsInProgress={renameIsInProgress}
        rename={this.rename}
        itemToDelete={itemToDelete}
        itemToUnshare={itemToUnshare}
        multipleSelectItems={multipleSelectItems}
        onUploadFilesClick={this.onUploadFilesClick}
        searchQuery={searchQuery}
        itemToDownload={itemToDownload}
        moveOrCopyFolderDetails={moveOrCopyFolderDetails}
        fetchSearchDataForMoveCopy={this.fetchSearchDataForMoveCopy}
        showMoveOrCopyToList={showMoveOrCopyToList}
        folderListFetchInProgress={folderListFetchInProgress}
        pasteFile={this.pasteFile}
        pageNo={pageNo}
        sortFileList={this.sortFileList}
        removeStateValuesOnFileOperation={this.removeStateValuesOnFileOperation}
        itemToMove={itemToMove}
        itemToCopy={itemToCopy}
        renderUploadFile={renderUploadFile}
      />
    )
  }

  renderErrorMessage = () => {
    const { errorMsg } = this.state
    return (
      errorMsg.msg !== '' && (
        <div className="error__msg show">
          <div
            className={`ppvx_alert ppvx_alert--type_${errorMsg.status}`}
            role="alert"
          >
            {errorMsg.msg}.
          </div>
        </div>
      )
    )
  }

  setBaseFolder = (path) => {
    this.props.actions.setBaseFolder(path === apiConstants.Root ? '/' : path)
  }

  renderBreadCrumbs = () => {
    const { baseFolder } = this.props
    return (
      <BreadCrumbs
        {...this.props}
        baseFolder={baseFolder}
        setBaseFolder={this.props.setBaseFolder}
        searchQuery={this.state.searchQuery}
        onBreadCrumbsRootParentClick={this.onBreadCrumbsRootParentClick}
        setPreviousBaseFolder={this.setPreviousBaseFolder}
        handleClearDate={this.props.handleClearDate}
        constructErrorMessage={this.constructErrorMessage}
      />
    )
  }

  render() {
    const {
      showPagination,
      viewType,
      showProperties,
      searchQuery,
      pageNo,
      showDeliveryStatus,
      showFileHistory,
      alertBox,
    } = this.state
    const totalElements = this.props.files.total || 0
    const { limit } = this.props
    const totalPages = Math.ceil(totalElements / limit)

    return (
      <div className="view__container-box">
        {this.renderBreadCrumbs()}
        {this.renderButtonsAndFilters()}
        {Object.keys(searchQuery).length > 0 && (
          <RenderAppliedFilter
            {...this.props}
            searchQuery={searchQuery}
            clearAppliedFilter={this.clearAppliedFilter}
          />
        )}
        <div className="app__tree-grid-holder">
          {this.renderErrorMessage()}
          {viewType === 'grid' ? this.renderGridView() : this.renderListView()}
        </div>
        <div>
          {totalPages > 1 && showPagination && (
            <Pagination
              {...this.props}
              totalPages={totalPages}
              pageNo={pageNo}
              onPaginationClick={this.onPaginationClick}
              searchQuery={searchQuery}
              totalElements={totalElements}
              pageLimit={limit}
            />
          )}
        </div>
        {showProperties && this.renderProperties()}
        {showDeliveryStatus && this.renderDeliveryProperities()}
        {showFileHistory && this.renderFileHistory()}
        <AlertBox
          {...this.props}
          alertBox={alertBox}
          checkAlertBoxAction={this.checkAlertBoxAction}
          renderLocalizedAction={this.renderLocalizedAction}
        />
      </div>
    )
  }
}
export default Views
